import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types'
import { ContentType } from '@entries/content-types'
import ContentfulAsset from '@entries/contentful-asset'
import ContentfulCta from '@entries/contentful-cta'
import ContentfulDeprecatedPageLink from '@entries/contentful-deprecated-page-link'
import ContentfulExternalLink from '@entries/contentful-external-link'
import ContentfulFaqPageLink from '@entries/contentful-faq-page-link'
import contentfulGraphs from '@entries/contentful-graphs'
import ContentfulImageInline from '@entries/contentful-image-inline'
import ContentfulPDFLink from '@entries/contentful-pdf-link'
import ContentfulStaticPageLink from '@entries/contentful-static-page-link'
import { bold } from '@render-mark/bold'
import { code } from '@render-mark/code'
import { italic } from '@render-mark/italic'
import { underline } from '@render-mark/underline'
import { deprecatedHeading2 } from '@render-node/deprecated-heading-2'
import { deprecatedHeading3 } from '@render-node/deprecated-heading3'
import { deprecatedParagraph } from '@render-node/deprecated-paragraph'
import { heading4 } from '@render-node/heading-4'
import { heading5MarginTop } from '@render-node/heading-5-margin-top'
import { heading6 } from '@render-node/heading-6'
import { hr } from '@render-node/hr'
import { hyperlink } from '@render-node/hyperlink'
import { listItem } from '@render-node/list-item'
import { olList } from '@render-node/ol-list'
import { quote } from '@render-node/quote'
import { ulList } from '@render-node/ul-list'
import { type RichTextOptions } from '@resolvers/rich-text/types'

export const modalRichText: RichTextOptions = {
  renderMark: {
    [MARKS.UNDERLINE]: underline,
    [MARKS.ITALIC]: italic,
    [MARKS.CODE]: code,
    [MARKS.BOLD]: bold,
  },
  renderNode: {
    [BLOCKS.HEADING_2]: deprecatedHeading2,
    [BLOCKS.HEADING_3]: deprecatedHeading3,
    [BLOCKS.HEADING_4]: heading4,
    [BLOCKS.HEADING_5]: heading5MarginTop,
    [BLOCKS.HEADING_6]: heading6,
    [BLOCKS.QUOTE]: quote,
    [BLOCKS.OL_LIST]: olList,
    [BLOCKS.UL_LIST]: ulList,
    [BLOCKS.LIST_ITEM]: listItem,
    [BLOCKS.HR]: hr,
    [BLOCKS.PARAGRAPH]: deprecatedParagraph,
    [INLINES.HYPERLINK]: hyperlink,
    [INLINES.ASSET_HYPERLINK]: {
      [ContentType.ContentfulAsset]: ContentfulAsset,
    },
    [INLINES.ENTRY_HYPERLINK]: {
      [ContentType.ContentfulDeprecatedPage]: ContentfulDeprecatedPageLink,
      [ContentType.ContentfulStaticPage]: ContentfulStaticPageLink,
      [ContentType.ContentfulExternalLink]: ContentfulExternalLink,
      [ContentType.ContentfulPdfLink]: ContentfulPDFLink,
      [ContentType.ContentfulFaqPage]: ContentfulFaqPageLink,
    },
    [BLOCKS.EMBEDDED_ENTRY]: {
      [ContentType.ContentfulCta]: ContentfulCta,
      [ContentType.ContentfulGraph]: contentfulGraphs,
    },
    [INLINES.EMBEDDED_ENTRY]: {
      [ContentType.ContentfulImage]: ContentfulImageInline,
    },
  },
}
